import React from 'react';

import { useQueryClient } from 'react-query';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { UseMutationChangeReportName } from 'api/mutations/changeReportName.mutation';

import { BreadCrumbItem } from 'components/common/BreadCrumbItem/BreadCrumbItem';
import { BreadcrumbsSeparatorIcon } from 'components/common/Icons/common/BreadcrumbsSeparatorIcon/BreadcrumbsSeparatorIcon';
import { TitleEditName } from 'components/common/TitleEditName/TitleEditName';

import { Report } from 'components/Dashboards/Reporting/reporting.types';

import classes from './ReportNameWithLink.module.scss';

interface Props {
    report: Report | undefined;
}

export const ReportNameWithLink = ({ report }: Props) => {
    //queries
    const queryClient = useQueryClient();
    const { mutateAsync: mutateChangeReportName, isLoading } = UseMutationChangeReportName();

    //hooks
    const { handleSnackBar } = useCustomSnackBar();

    const handleReportNameChange = async (value: string) => {
        if (report) {
            await mutateChangeReportName(
                {
                    reportId: report.id,
                    name: value,
                },
                {
                    onSuccess: async () => {
                        await Promise.all([
                            queryClient.invalidateQueries('getReportList'),
                            queryClient.invalidateQueries('getReport'),
                        ]);
                        handleSnackBar('Report name updated', 'success');
                    },
                    onError: (error) => {
                        DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    },
                },
            );
        }
    };

    return (
        <div className={classes.reportNameWithLink}>
            <BreadCrumbItem label={'Reports'} to={AppRoutes.buildPath(AppRoutes.DASHBOARD_REPORTING_PATH)} />

            <div className={classes.box}>
                <BreadcrumbsSeparatorIcon />
            </div>

            <TitleEditName
                maxLength={100}
                value={report?.name ?? ''}
                onChange={handleReportNameChange}
                isLoading={isLoading}
            />
        </div>
    );
};
